export default __webpack_public_path__ + "static/hero-41408cf3922939c1f7c41ca88800588e.svg";